export default __webpack_public_path__ + "static/main-graphic-og-image-size-7ed682fe4473ec6a16a989211c5cf3fc.png";